module.exports = __webpack_public_path__ + "media/images/salle de fitness-41be0e78b4c7887ab14bdcf7c48c852c.svg";